import React from 'react';

interface AvatarCellProps {
  value?: unknown;
  src?: string;
  alt?: string;
  size?: 'small' | 'medium' | 'large';
  render?: () => React.ReactNode;
}

function AvatarCell({
  value,
  src,
  alt,
  size = 'medium',
  render,
}: AvatarCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  return (
    <div className={`data-cell__avatar data-cell__avatar--${size}`}>
      {src ? (
        <img
          src={src}
          alt={alt || String(value)}
          className="data-cell__avatar-image"
          width={size === 'small' ? 24 : size === 'large' ? 48 : 32}
          height={size === 'small' ? 24 : size === 'large' ? 48 : 32}
        />
      ) : (
        <div className="data-cell__avatar-placeholder">
          {String(value || '')
            .charAt(0)
            .toUpperCase()}
        </div>
      )}
    </div>
  );
}

export default AvatarCell;
